import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import { Link } from "react-router-dom";
import { fourPlaceHolder } from "modules/utilities/utility";

function TicketFeedbackTable({ data, isLoading }) {
  const [sortedData, setSortedData] = useState(data?.feedbacks);
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);

  useEffect(() => {
    setSortedData(data?.feedbacks);
  }, [data]);


  const handleSortDate = () => {
    if (!data) {
      return;
    }
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setSortedData([
        ...data?.feedbacks?.sort(
          (a, b) => moment(a.createdAt) - moment(b.createdAt)
        ),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setSortedData([
        ...data?.feedbacks?.sort(
          (a, b) => moment(b.createdAt) - moment(a.createdAt)
        ),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setSortedData([...data?.feedbacks]);
    }
  };

  return (
    <div className="mt-2">
      <div className="mt-1 shadow rounded">
        <div className="d-flex table-head rounded-top">
          <span className="p-3 fw-bold text-black flex-1">Customer Name</span>
          <span className="p-3 fw-bold text-black flex-1 text-center">
            Satisfied
          </span>
          <span className="p-3 fw-bold text-black flex-1 text-center">
            Experience
          </span>
          <span className="p-3 fw-bold text-black flex-1">Order Id</span>
          <span className="p-3 fw-bold text-black flex-1">
            Current Assignee
          </span>
          <span className="p-3 fw-bold text-black flex-1">Ticket Category</span>
          <span className="p-3 fw-bold text-black flex-1">
            Ticket Sub Category
          </span>
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                {opa == "asc" ? (
                  <span className="fw-bold">Click to sort ascending</span>
                ) : opa == "dsc" ? (
                  <span className="fw-bold">Click to sort Descending</span>
                ) : (
                  <span className="fw-bold">Click to cancel sort</span>
                )}
              </Tooltip>
            }
          >
            <th
              className="flex-1 align-top cursor-pointer"
              onClick={handleSortDate}
            >
              <span
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                <span className="fw-bold text-black"> Created At</span>
              </span>
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  paddingLeft: "1rem",
                }}
              >
                <div
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </div>
                <div
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "dsc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </div>
            </th>
          </OverlayTrigger>
        </div>
        {isLoading ? (
          fourPlaceHolder()
        ) : sortedData && sortedData?.length ? (
          sortedData?.map((ticket, index) => {
            const customer = ticket?.ticket?.[0]?.customer;
            const orderId = ticket?.ticket?.[0]?.source_meta?.order_display_id;
            const ticketCategory = ticket?.ticket?.[0]?.category;
            const ticketSubCategory = ticket?.ticket?.[0]?.sub_category;
            const assignee =
              ticket?.ticket?.[0]?.current_assignment?.first_name;
            return (
              <div
                className={`d-flex table-row border- border-top-0 ${
                  index === sortedData?.length - 1 && `rounded-bottom`
                }`}
              >
                <span className="p-2 flex-1 text-break text-wrap">
                  <Link to={`/lead-details/${ticket?.ticket[0]?.case_id}`}>
                    <div className="fw-bold text-primary">
                      {" "}
                      {customer?.first_name}{" "}
                    </div>
                  </Link>
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap text-center">
                  {ticket?.satisfied}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap text-center">
                  {ticket?.experience}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap">
                  {orderId}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap">
                  {assignee}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap">
                  {ticketCategory}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap">
                  {ticketSubCategory}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap">
                  {moment(ticket?.createdAt).format("DD/MM/YY HH:mm:ss")}
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            No Data Available <NoData />
          </div>
        )}
      </div>
    </div>
  );
}

export default TicketFeedbackTable;
